import { useEffect } from 'react'
import { useSubscriptionStore } from '../stores/subscriptionStore'

/**
 * Hook to load user subscriptions on every authenticated page load.
 * Delegates fetch logic to the Zustand store action.
 */
export const useSubscriptionLoader = (customerId?: string, isAuthenticated?: boolean) => {
  const fetchSubscriptions = useSubscriptionStore((state) => state.fetchSubscriptions)
  const isLoading = useSubscriptionStore((state) => state.isLoading)

  useEffect(() => {
    if (isAuthenticated && customerId) {
      fetchSubscriptions()
    }
  }, [isAuthenticated, customerId, fetchSubscriptions])

  return { isLoading }
}
